(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  window.onload = function() {
    if (window.location.hash === "#success-message") {
      var element = document.getElementById("success-message");
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  /************** INGRANDISCE LE PRIME LETTERE DELLE PAGINE POLICY ****************/
      document.querySelectorAll('.cont u').forEach(el => {
        // Converte tutto il testo in minuscolo
        const lowerText = el.textContent.toLowerCase();
        // Trasforma in Capitalize: ogni parola con la prima lettera maiuscola
        const capitalizedText = lowerText.replace(/\b\w/g, char => char.toUpperCase());
        el.textContent = capitalizedText;
      });


        var coll = document.getElementsByClassName("footer-collapsible");
        var i;

        for (i = 0; i < coll.length; i++) {
          coll[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var content = this.nextElementSibling;
            if (content.style.maxHeight){
              content.style.maxHeight = null;
            } else {
              content.style.maxHeight = content.scrollHeight + "px";
            }
          });
        }


        var cont = document.getElementsByClassName("footer-content");
        var i;

        for (i = 0; i < cont.length; i++) {
          cont[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var content = this.nextElementSibling;
            if (content.style.maxHeight){
              content.style.maxHeight = null;
            } else {
              content.style.maxHeight = content.scrollHeight + "px";
            }
          });
        }

      /********* OPEN CHAT BOT IBOX ***********/
      window.ac = window.ac || {};
      ac.chatLink = document.querySelector("a[href='#chat']");

      // Seleziona il link con ID open-inbox
      ac.inboxLink = document.getElementById("open-inbox");

      if (ac.chatLink) {
        ac.chatLink.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();

          document.getElementById("ShopifyChat").shadowRoot.querySelector("button.chat-toggle").click();
        });
      }
      // Aggiungi l'evento click per il link open-inbox
      if (ac.inboxLink) {
        ac.inboxLink.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();

          // Simula il click sul pulsante di apertura della chat
          document.getElementById("ShopifyChat").shadowRoot.querySelector("button.chat-toggle").click();
        });
      }


        // Start IE11 compatibility
          if (!!window.MSInputMethodContext && !!document.documentMode) {
            // CSSVar Polyfill
            document.write('<script src="https://cdn.jsdelivr.net/gh/nuxodin/ie11CustomProperties@4.1.0/ie11CustomProperties.min.js"></script>');

            document.documentElement.className = document.documentElement.className.replace('js', 'no-js');

            document.addEventListener('DOMContentLoaded', function () {
              var elsToLazyload = document.querySelectorAll('.lazyload');
              for (var i = 0; i < elsToLazyload.length; i++) {
                var elToLazyLoad = elsToLazyload[i];
                elToLazyLoad.removeAttribute('src');
                var src = elToLazyLoad.getAttribute('data-src').replace('_{width}x.', '_600x.');
                elToLazyLoad.setAttribute('src', src);
                elToLazyLoad.classList.remove('lazyload');
                elToLazyLoad.classList.add('lazyloaded');
              }
            });
          }

  // Access the shadow root

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
let scrollPosition = 0;

window.addEventListener("load", function() {
    // Controlla se l'utente ha già visto il popup e memorizza la data in cui è stato mostrato
    const lastPopupShown = localStorage.getItem('popupShownDate');
    const urlParams = new URLSearchParams(window.location.search);
    const customerPosted = urlParams.get('customer_posted');

    // Funzione per calcolare la differenza di giorni tra due date
    function daysSinceLastPopup(lastDate) {
        const currentDate = new Date();
        const lastPopupDate = new Date(lastDate);
        const timeDifference = currentDate - lastPopupDate;
        const daysDifference = timeDifference / (1000 * 3600 * 24); // Converti millisecondi in giorni
        return daysDifference;
    }

    // Mostra il popup solo se non è già stato visto nelle ultime 24 ore e l'utente non si è iscritto
    // && (!lastPopupShown || daysSinceLastPopup(lastPopupShown) >= 1)
    if (customerPosted !== 'true') {
        // Funzione per mostrare il popup dopo il 20% di scorrimento della pagina
        function showPopupOnScroll() {
            const currentScroll = window.scrollY;
            const pageHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrollPercentage = (currentScroll / pageHeight) * 100;

            if (scrollPercentage > 20 ) {
                scrollPosition = currentScroll; // Memorizza la posizione dello scroll
                const popup = document.querySelector("#popup");
                
                popup.classList.add("show"); 
                document.body.classList.add("lock-scroll");
                document.body.style.top = `-${scrollPosition}px`; // Mantiene la posizione dello scroll
                
                // Salva la data corrente come l'ultima volta che il popup è stato mostrato
                localStorage.setItem('popupShownDate', new Date().toISOString());

                window.removeEventListener('scroll', showPopupOnScroll); // Rimuovi l'evento dopo aver mostrato il popup
            }
        }

        // Aggiungi l'evento scroll per controllare quando mostrare il popup
        window.addEventListener('scroll', showPopupOnScroll);
    }
});

document.addEventListener("DOMContentLoaded", function () {
  const popup = document.querySelector("#popup");
  const closePopupBtn = document.querySelector("#close-popup");
  const successMessage = document.querySelector(".user-registered-correct");
  const popupForm = document.querySelector("#popup-form");

  const urlParams = new URLSearchParams(window.location.search);
  const customerPosted = urlParams.get("customer_posted");

  // Gestione popup per form inviato con successo
  if (
    customerPosted === "true" &&
    popupForm &&
    document.activeElement === popupForm.querySelector("input[type='email']")
  ) {
    if (popup) {
      popup.classList.add("show");
      if (successMessage) {
        successMessage.style.display = "block";
      }
      setTimeout(() => {
        popup.classList.remove("show");
        popup.style.display = "none";
        // Ripristina la posizione dopo la chiusura
        document.body.style.top = "";
        document.body.classList.remove("lock-scroll");
        window.scrollTo({ top: scrollPosition, behavior: "smooth" });
      }, 3000);
    }
  }

  // Chiusura manuale del popup
  if (closePopupBtn && popup) {
    closePopupBtn.addEventListener("click", function () {
      popup.classList.remove("show");
      popup.style.display = "none";
      // Rimuovi il blocco e ripristina lo scroll
      document.body.style.top = "";
      document.body.classList.remove("lock-scroll");
      window.scrollTo({ top: scrollPosition, behavior: "smooth" });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["progress-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('scroll', function() {
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    var scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight - 400;
    var scrolled = (scrollTop / scrollHeight) * 100;

    if (scrolled > 100) scrolled = 100; // Evita che superi il 100%

    document.getElementById('progress-bar').style.width = scrolled + '%';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-newsletter"] && !Shopify.designMode) return;
  try {
    
    $('input[type=date]').each(function(){
      var input=$(this);
      var id=input.attr('id');
      if (!id){
          id='RandomGeneratedId_'+Math.random().toString(36).substring(7);
          input.attr('id',id);
      }
      var placeholder=input.attr('placeholder');
      if (placeholder){
          $('head').append('<style> #'+id+':before{ content:"'+placeholder+'"; width:100%; color:#AAA; } #'+id+':focus:before,#'+id+'.not_empty:before{ content:none }</style>');
      }
      input.on('change keyup',function(){
          if ($(this).val()){
              $(this).addClass('not_empty')
          }else{
              $(this).removeClass('not_empty')
          }
          return false;
      });
  });

  } catch(e) { console.error(e); }
})();
})();
